'use client';

/** @app — application layer; owned per-fork (LMS / OTT). See PLATFORM_FILES.md. */
import Link from 'next/link';
import { useTranslation } from 'react-i18next';

export interface BreadcrumbProps {
  tenantSlug: string;
  categorySlug?: string;
  categoryName?: string;
  courseTitle: string;
}

export function Breadcrumb({
  tenantSlug,
  categorySlug,
  categoryName,
  courseTitle,
}: BreadcrumbProps) {
  const { t } = useTranslation('common');
  const { t: tb } = useTranslation('site-builder-blocks');
  return (
    <nav aria-label={tb('courseDetail.breadcrumb.label')} className="cd-breadcrumb">
      <Link href={`/${tenantSlug}`}>{t('title.homepage')}</Link>
      <span className="cd-breadcrumb-sep">/</span>
      <Link href={`/${tenantSlug}/catalog`}>{t('label.courses')}</Link>
      {categorySlug && categoryName && (
        <>
          <span className="cd-breadcrumb-sep">/</span>
          <Link href={`/${tenantSlug}/catalog?cat=${encodeURIComponent(categorySlug)}`}>
            {categoryName}
          </Link>
        </>
      )}
      <span className="cd-breadcrumb-sep">/</span>
      <span aria-current="page" title={courseTitle}>
        {courseTitle.length > 40 ? `${courseTitle.slice(0, 40)}…` : courseTitle}
      </span>
    </nav>
  );
}
